import React from 'react'
import i18n from 'i18next'
import PageHeader from '#components/m/PageHeader'
import Headline from '#components/a/Headline'
import {LinkWithArrow} from '#components/m/MeineOrganisation/LinkWithArrow'
import Text from '#components/a/Text'
import {useRessourcenPlan} from '#hooks/store/useRessourcenPlan'
import Loading from '#components/a/Loading'
import PlanRessourceButton from '#components/m/Ressourcenplanung/PlanRessourceButton'
import RessourcenPlanungGrid from '#components/o/RessourcenPlanung/RessourcenPlanungGrid'

export function Ressourcenplanung() {
  const {isLoading, ressourcenPlan} = useRessourcenPlan()

  return (
    <div className="ressourcenplanung">
      <PageHeader
        headline={
          <div>
            <Headline importance={2} modifier="section" text={i18n.t('ressourcenplanung_title')} />
            <LinkWithArrow to="/versetzungsplan" text={i18n.t('link_text_to_versetzungsplan')} />
          </div>
        }
        button={<PlanRessourceButton />}
      />
      {isLoading && <Loading />}
      {!isLoading && ressourcenPlan.ressourcenOfAbteilung && ressourcenPlan.ressourcenOfAbteilung.length === 0 && (
        <Text text={i18n.t('ressourcenplanung_empty_text')} />
      )}
      {!isLoading && ressourcenPlan.ressourcenOfAbteilung && ressourcenPlan.ressourcenOfAbteilung.length > 0 && (
        <RessourcenPlanungGrid ressourcenPlan={ressourcenPlan} />
      )}
    </div>
  )
}

export default Ressourcenplanung
